import { render, staticRenderFns } from "./complianceLimts.vue?vue&type=template&id=203609da&scoped=true"
import script from "./complianceLimts.vue?vue&type=script&lang=js"
export * from "./complianceLimts.vue?vue&type=script&lang=js"
import style0 from "./complianceLimts.vue?vue&type=style&index=0&id=203609da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203609da",
  null
  
)

export default component.exports